module.exports = __webpack_public_path__ + "assets/img/icon_history.048a1db9.svg";